var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('router-link',{staticClass:"logo",attrs:{"to":"/","id":""}},[_c('img',{attrs:{"src":require("../../static/images/diu_white.png"),"alt":"DIU"}}),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Dhaka International University")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-656a696a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarHeader.vue
// module id = null
// module chunks = 